import type React from "react";

import { NumberField as DSNumberField } from "@eisox/design-system";

type RootProps = React.ComponentProps<typeof DSNumberField.Root>;
type InputProps = React.ComponentProps<typeof DSNumberField.Input>;
type ButtonProps = React.ComponentProps<typeof DSNumberField.Decrement>;

export interface AppNumberFieldProps extends Omit<RootProps, "children"> {
  inputProps?: InputProps;
  decrementProps?: ButtonProps;
  incrementProps?: ButtonProps;
}

export const NumberField: React.FC<AppNumberFieldProps> = ({
  inputProps,
  decrementProps,
  incrementProps,
  ...rootProps
}) => {
  return (
    <DSNumberField.Root {...rootProps}>
      <DSNumberField.Group>
        <DSNumberField.Decrement {...decrementProps} />
        <DSNumberField.Input {...inputProps} />
        <DSNumberField.Increment {...incrementProps} />
      </DSNumberField.Group>
    </DSNumberField.Root>
  );
};
